import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ListItem: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <li style={{ fontSize: 13, color: '#333', lineHeight: 1.8, paddingLeft: 4 }}>
    - &nbsp;{children}
  </li>
);

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    fontFamily: "'IBM Plex Sans Arabic', 'Segoe UI', Arial, sans-serif",
    backgroundColor: '#fff',
    minHeight: '100vh',
    padding: '24px 20px',
    boxSizing: 'border-box',
    maxWidth: 480,
    margin: '0 auto',
  },
  body: {
    paddingLeft: 4,
  },
  intro: {
    fontSize: 13,
    color: '#111',
    marginBottom: 14,
    lineHeight: 1.6,
  },
  text: {
    fontSize: 13,
    color: '#333',
    marginBottom: 12,
    lineHeight: 1.7,
    textAlign: 'justify',
  },
  email: {
    fontSize: 13,
    fontWeight: 600,
    color: '#111',
    marginBottom: 12,
  },
  emailLink: {
    color: '#111',
    textDecoration: 'none',
  },
};

const ReportProblemPage: React.FC = () => {
  const location = useLocation();
  const isAr = new URLSearchParams(location.search).get('language') === 'ar';

  useEffect(() => {
    document.documentElement.dir = isAr ? 'rtl' : 'ltr';
  }, [isAr]);

  return (
    <div style={{ ...styles.container, direction: isAr ? 'rtl' : 'ltr' }}>
      <div style={styles.body}>
        <p style={styles.intro}>
          {isAr ? (
            <>هل تواجه مشكلة في التطبيق؟<br />نحن هنا للمساعدة.</>
          ) : (
            <>Experiencing an issue within the app?<br />We're here to help.</>
          )}
        </p>

        <p style={styles.text}>
          {isAr
            ? 'إذا واجهت خطأ تقنيًا، أو مشكلة في الحساب، أو مشكلة في الإعلان، أو أي سلوك غير متوقع، يرجى التواصل معنا عبر البريد الإلكتروني مع التفاصيل ذات الصلة.'
            : 'If you encounter a technical error, account issue, advertisement problem, or any unexpected behavior, please contact us via email with the relevant details.'}
        </p>

        <p style={styles.text}>
          {isAr
            ? 'لمساعدتنا في حل مشكلتك بشكل أسرع، يرجى تضمين:'
            : 'To help us resolve your issue faster, please include:'}
        </p>

        <ul style={{ paddingLeft: 0, paddingRight: 0, listStyle: 'none', marginBottom: 14 }}>
          <ListItem>{isAr ? 'وصف واضح للمشكلة' : 'A clear description of the problem'}</ListItem>
          <ListItem>{isAr ? 'اسم حسابك أو البريد الإلكتروني المسجل' : 'Your account name or registered email'}</ListItem>
          <ListItem>{isAr ? 'رابط الإعلان (إن وجد)' : 'The ad link (if applicable)'}</ListItem>
          <ListItem>{isAr ? 'لقطة شاشة، إن أمكن' : 'A screenshot, if available'}</ListItem>
        </ul>

        <p style={styles.email}>
          {isAr ? 'البريد الإلكتروني:' : 'Email:'}{' '}
          <a href="mailto:support@fesilah.com" style={styles.emailLink}>
            support@fesilah.com
          </a>
        </p>

        <p style={styles.text}>
          {isAr
            ? 'سيراجع فريق الدعم رسالتك ويرد عليك في أقرب وقت ممكن.'
            : 'Our support team will review your message and respond as soon as possible.'}
        </p>

        <p style={styles.text}>
          {isAr
            ? 'شكرًا لمساعدتنا في تحسين فِصالة.'
            : 'Thank you for helping us improve Fesilah.'}
        </p>
      </div>
    </div>
  );
};

export default ReportProblemPage;
